import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const servicesData = [
  {
    id: 1,
    title: "GST Services",
    description: "Stay compliant with timely GST registration, filing and advisory services.",
    icon: "FileText"
  },
  {
    id: 2,
    title: "Income Tax",
    description: "Minimize your tax liability with expert planning and accurate filing.",
    icon: "Calculator"
  },
  {
    id: 3,
    title: "Audit Services",
    description: "Ensure compliance and financial transparency with professional audit solutions.",
    icon: "ClipboardCheck"
  },
  {
    id: 4,
    title: "Accounting",
    description: "Focus on growing your business while we manage your books.",
    icon: "BookOpen"
  },
  {
    id: 5,
    title: "Business Registration",
    description: "Launch your business with hassle-free registrations and compliance support.",
    icon: "Building2"
  },
  {
    id: 6,
    title: "Financial Advisory",
    description: "Make informed business decisions with expert financial insights.",
    icon: "TrendingUp"
  }
];

export const contactInfo = {
  email: "accounts@medaccconsultancy.com",
  phone: "9167682864",
  businessName: "Medacc Consultancy"
};

// API functions - Replace mock with real API calls
export const submitContactForm = async (formData) => {
  try {
    const response = await axios.post(`${API}/contact`, formData);
    return { success: true, message: "Thank you! We'll contact you soon.", data: response.data };
  } catch (error) {
    console.error("Contact form submission error:", error);
    throw new Error(error.response?.data?.detail || "Failed to submit contact form");
  }
};

export const bookAppointment = async (appointmentData) => {
  try {
    const response = await axios.post(`${API}/appointments`, appointmentData);
    return { 
      success: true, 
      message: "Appointment booked successfully! We'll confirm shortly.",
      data: response.data
    };
  } catch (error) {
    console.error("Appointment booking error:", error);
    throw new Error(error.response?.data?.detail || "Failed to book appointment");
  }
};

export const submitServiceRequest = async (serviceData) => {
  try {
    const response = await axios.post(`${API}/service-requests`, serviceData);
    return { 
      success: true, 
      message: "Service request received! Our team will reach out soon.",
      data: response.data
    };
  } catch (error) {
    console.error("Service request error:", error);
    throw new Error(error.response?.data?.detail || "Failed to submit service request");
  }
};

// Admin functions to get all submissions
export const getAllContacts = async () => {
  try {
    const response = await axios.get(`${API}/contact`);
    return response.data;
  } catch (error) {
    console.error("Error fetching contacts:", error);
    throw error;
  }
};

export const getAllAppointments = async () => {
  try {
    const response = await axios.get(`${API}/appointments`);
    return response.data;
  } catch (error) {
    console.error("Error fetching appointments:", error);
    throw error;
  }
};

export const getAllServiceRequests = async () => {
  try {
    const response = await axios.get(`${API}/service-requests`);
    return response.data;
  } catch (error) {
    console.error("Error fetching service requests:", error);
    throw error;
  }
};

